import { natures } from "@/mocks/natures";
import SectionHeading from "./SectionHeading";

export default function NatureSection() {
  return (
    <section id="nature" className="w-full bg-foreground-950 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3">
          <span className="h-px w-8 bg-accent-400" />
          <span className="font-label text-xs md:text-sm tracking-[0.28em] text-accent-300 uppercase">
            Human nature
          </span>
        </div>
        <h2 className="mt-4 font-heading text-2xl md:text-4xl font-semibold text-background-50 leading-snug">
          人性母题：伦理片真正反复回答的五个问题
        </h2>
        <p className="mt-4 text-sm md:text-base leading-relaxed text-background-50/70 max-w-3xl">
          换个题材、换个年代，这些作品其实一直在问同样几件事。认识这些母题，再看任何一部伦理片时都会更有抓手。
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {natures.map((n) => (
            <div
              key={n.id}
              className="flex flex-col rounded-lg bg-background-50/5 border border-background-50/15 p-6 hover:bg-background-50/10 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                <i className={`${n.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg md:text-xl font-semibold text-background-50">
                {n.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-background-50/75">{n.desc}</p>
              <p className="mt-4 pt-4 border-t border-background-50/15 font-label text-xs leading-relaxed text-accent-300">
                {n.point}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}